<div class="listing pt-4">
  <div class="status-filters d-flex">
    <button
      *ngFor="let filter of STATUS_FILTERS"
      type="button"
      class="filter-chip d-flex align-items-center flex-shrink-0"
      [class.selected]="selectedStatus === filter.status"
      (click)="selectStatus(filter.status)"
    >
      <mat-icon *ngIf="selectedStatus === filter.status" class="chip-check">check</mat-icon>
      {{ filter.label | translate }}
    </button>
  </div>
  <div class="scroll-container">
    <div
      *ngFor="let credential of filteredCredentials"
      class="credential-card d-flex align-items-center pointer-cursor"
      (click)="
        viewCredentialDetails(
          credential?.cardId,
          credential?.cardName,
          credential?.badgeId,
          credential?.cardStatus,
          credential?.disable
        )
      "
    >
      <div class="card-icon-wrapper flex-shrink-0">
        <img alt="Fob Icon" src="assets/icons/ic-fob-only-account.svg" />
      </div>
      <div class="card-text flex-fill">
        <div class="card-name">
          <app-profile-tooltip [showHelpCursor]="true">
            {{
            credential?.cardName
            ? credential?.cardName
            : ("NOT_AVAILABLE" | translate)
            }}
          </app-profile-tooltip>
        </div>
        <div class="card-id d-flex align-items-center">
          <span class="flex-shrink-0">{{ "ID_LABEL" | translate }}</span>
          <span class="card-id-value">
            <app-profile-tooltip [showHelpCursor]="true">
              {{
              credential?.badgeId
              ? credential?.badgeId
              : ("NOT_AVAILABLE" | translate)
              }}
            </app-profile-tooltip>
          </span>
          <span class="status-pill" [ngClass]="getStatusClass(credential?.cardStatus)">
            {{ getStatusLabel(credential?.cardStatus) }}
          </span>
        </div>
        <div *ngIf="credential?.creatorName" class="card-user">
          <app-profile-tooltip [showHelpCursor]="true">
            {{ credential?.creatorName }}
          </app-profile-tooltip>
        </div>
      </div>
      <img class="chevron-icon flex-shrink-0" src="/assets/svg/ico-chevron-forward-outline.svg" alt="Details" />
    </div>
    <p *ngIf="!filteredCredentials?.length" class="no-filter-result text-center">
      {{ "NO_STANDARD_CREDENTIALS_FOR_STATUS" | translate }}
    </p>
  </div>
  <!-- MPC-7907 Commented for future use not needed for now -->
  <!--  <div class="d-flex add-credentials pointer-cursor">
    <span class="align-self-center col-2">
      <img
        alt="Credential Icon"
        src="assets/svg/credential-card-grey.svg"
        class="left-icon"
      />
    </span>
    <div
      class="d-flex flex-column justify-content-center align-items-center col-8"
    >
      <span class="title bold align-self-center">
        {{ 'ADD_CREDENTIAL' | translate }}
      </span>
    </div>

    <span
      class="selected-value-container align-self-center col-2 text-right pr-1 pb-1"
    >
      <span class="btn-not-text">
        <button class="icon-button" type="button">
          <img class="icon" src="/assets/svg/ico-add.svg" />
        </button>
      </span>
    </span>
  </div> -->
</div>
